<template>
<div>
  {{description.data}}
</div>
</template>

<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import ImageFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/ImageFormFieldConfig";

export default {
  name: "DescriptionByAIRenderer",
  components: {},
  mounted() {

  },

  methods: {

  },
  watch: {
    validatedField: function (value) {
      this.description = this.validatedField?.value;
    },
    "validatedField.value": function (value) {
      this.description = this.validatedField?.value;
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: ImageFormFieldConfig, required: true},
  },

  data: function() {
    return {
      description: ''
    }
  },

  computed: {
    colorStyle() {
      if (this.description.data.main_color) {
        const { r, g, b } = this.description.data.main_color;
        return {
          backgroundColor: `rgb(${r}, ${g}, ${b})`,
          width: '20px',
          height: '20px'
        };
      }
      return {};
    }
  },
}
</script>

<style scoped>
.grid-att {
  display: grid;
  grid-template-columns: auto auto auto;
}

@media screen and (max-width: 1050px) {
  .grid-att {
    grid-template-columns: auto auto;
  }
  
}

@media screen and (max-width: 850px) {
  .grid-att {
    grid-template-columns: auto;
  }

}

</style>